// 美团APP
// 点评APP
export default {
  appName: 'meituan',
  useKNB: true,
  sellChannel: 2,
  theme: 'meituan'
};